import { Input } from '@eleo-rh/core-ui'
import cx from 'classnames'
import Button from 'components/UI/CoreUIButton'
import { useOnClickOutside } from 'hooks/utils'
import PropTypes from 'prop-types'
import { useEffect, useRef, useState } from 'react'

function ConfirmInput({ value, setValue, onConfirm, onCancel, inputProps, cancelOnClickOutside }) {
  const [edition, setEdition] = useState(false)
  const inputRef = useRef(null)

  const enterEditionMode = () => {
    setEdition(true)
  }

  useEffect(() => {
    if (edition) inputRef.current.select()
  }, [edition])

  const confirm = () => {
    setEdition(false)
    onConfirm()
  }

  const cancel = () => {
    setEdition(false)
    onCancel()
  }

  const readonly = (
    <>
      <Button variant="tertiary" rightIcon="pen" size="small" status="neutral" onClick={enterEditionMode}>
        {value}
      </Button>
    </>
  )

  const editing = (
    <div className="flex items-center gap-1">
      <Input ref={inputRef} {...inputProps} className="" value={value} onChange={e => setValue(e.target.value)} />
      <Button
        variant="secondary"
        singleIcon="check"
        size="small"
        className={cx('text-(--primary)', { 'mid-opacity': !onConfirm })}
        onClick={onConfirm ? confirm : null}
      />
      <Button variant="secondary" singleIcon="xmark" size="small" status="error" onClick={cancel} />
    </div>
  )

  const mainRef = useRef(null)
  useOnClickOutside(mainRef, () => {
    if (cancelOnClickOutside) {
      cancel()
    }
  })

  return (
    <div className="flex justify-center items-center" ref={mainRef}>
      {edition ? editing : readonly}
    </div>
  )
}

ConfirmInput.propTypes = {
  value: PropTypes.string,
  setValue: PropTypes.func,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  inputProps: PropTypes.object,
  cancelOnClickOutside: PropTypes.bool,
}

export default ConfirmInput
